import { LocaleMeta } from './LocaleMeta';

/**
 * Singleton store for LocaleMeta.
 * Provides global access to the current user's locale metadata.
 *
 * Usage:
 *   import { LocaleMetaStore } from 'core';
 *   const localeMeta = LocaleMetaStore.getInstance().get();
 */
export class LocaleMetaStore {
  private static instance: LocaleMetaStore;
  private localeMeta: LocaleMeta | undefined;

  private constructor () {
    /* no-op */
  }

  static getInstance (): LocaleMetaStore {
    if (!LocaleMetaStore.instance) {
      LocaleMetaStore.instance = new LocaleMetaStore();
    }
    return LocaleMetaStore.instance;
  }

  set (localeMeta: LocaleMeta | undefined): void {
    this.localeMeta = localeMeta;
  }

  get (): LocaleMeta | undefined {
    return this.localeMeta;
  }

  clear (): void {
    this.localeMeta = undefined;
  }
}
